import { render } from "./GetCertificateCSR.vue?vue&type=template&id=049da478&scoped=true"
import script from "./GetCertificateCSR.vue?vue&type=script&lang=js"
export * from "./GetCertificateCSR.vue?vue&type=script&lang=js"

import "./GetCertificateCSR.vue?vue&type=style&index=0&id=049da478&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049da478"]])

export default __exports__